<div class="details">
    @if (value) {
        <div class="details-value">
            <div class="details-value-title" id="entry-value">
                {{ value }}
            </div>
        </div>
    }
    <div class="details-label">
        <div class="details-label-title" id="entry-label">
            {{ title }}
        </div>
    </div>
</div>
@if (attributes) {
    <div class="attributes" id="entry-attributes">
        <ng-content select="fui-attributed-list-entry-attributes"></ng-content>
    </div>
}
@if (link) {
    <div class="action" id="action">
        <div class="action-media">
            <fui-icon [height]="16" [icon]="'chevron-right'" [width]="8"></fui-icon>
        </div>
    </div>
}
